import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  pageContainer: {
    padding: 20,
    flexDirection: 'column',
    width: '100%',
  },

  // --- Via section ---
  viaSection: {
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  viaLabel: {
    fontSize: 7,
    color: '#aaaaaa',
    textAlign: 'right',
    marginBottom: 4,
  },

  // --- Title row ---
  titleRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: 12,
    marginBottom: 10,
  },
  titleText: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  receiptNumber: {
    fontSize: 10,
    color: '#666666',
    marginTop: 3,
  },

  // --- Value box ---
  valueBox: {
    backgroundColor: '#eef2fb',
    border: '1px solid #b8c8e8',
    borderRadius: 4,
    paddingHorizontal: 14,
    paddingVertical: 8,
    alignItems: 'flex-end',
  },
  valueLabelText: {
    fontSize: 7,
    color: '#778899',
    marginBottom: 2,
  },
  valueAmountText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1a3a6b',
  },

  // --- Description box ---
  descriptionBox: {
    border: '1px solid #dde3ed',
    borderRadius: 4,
    padding: 10,
    marginBottom: 8,
  },
  descriptionText: {
    fontSize: 10,
    lineHeight: 1.6,
    textAlign: 'justify',
  },
  textBold: {
    fontWeight: 'bold',
  },

  // --- Extra details row ---
  detailsRow: {
    flexDirection: 'row',
    marginBottom: 8,
  },
  detailItem: {
    marginRight: 24,
  },
  detailLabel: {
    fontSize: 7,
    color: '#778899',
    marginBottom: 2,
  },
  detailValue: {
    fontSize: 10,
    color: '#222222',
  },

  // --- Observation box ---
  observationBox: {
    backgroundColor: '#fafafa',
    border: '1px solid #e4e4e4',
    borderRadius: 4,
    padding: 8,
    marginBottom: 8,
  },
  observationLabel: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#666666',
    marginBottom: 3,
  },
  observationText: {
    fontSize: 10,
    color: '#333333',
  },

  // --- Date row ---
  dateRow: {
    marginTop: 6,
    marginBottom: 2,
    alignItems: 'flex-end',
  },
  dateText: {
    fontSize: 9,
    color: '#555555',
  },

  // --- Cut line ---
  cutLineRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
    paddingHorizontal: 4,
  },
  cutLinePart: {
    flex: 1,
    borderTop: '1px dashed #bbbbbb',
    marginTop: 4,
  },
  cutLineText: {
    fontSize: 7,
    color: '#bbbbbb',
    marginHorizontal: 10,
  },
});
